import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Map } from "immutable";

import { loadRecord } from "MODULES/shared/decorators";
import resourceTypes from "MODULES/shared/types/resourceTypes";
import Attachments from "MODULES/shared/components/Attachments/Attachments";
import Notes from "MODULES/shared/components/Notes/Notes";
import { ATTACHMENT_TYPES } from "MODULES/IncomingQuotes/constants";
import { CONTACT } from "MODULES/companies/constants";
import { COMPANY } from "APP_ROOT/constants";
import { PORTAL_PURCHASE } from "MODULES/PurchaseOrders/constants";
import { Col } from "react-bootstrap";
import { show as getQuote } from "../actions";
import LineItemsTable from "./LineItems/LineItemsTable";
import DetailsTable from "./DetailsTable";
import Header from "./Header/Header";
import { incomingQuotePagination } from "../pagination";

const legacyWarning = (
  <div className="alert alert-danger">
    <strong>Legacy Quote</strong> Company and contact must be assigned
  </div>
);

export class Detail extends Component {
  static propTypes = {
    incomingQuote: PropTypes.instanceOf(Map),
    expire: PropTypes.func.isRequired
  };

  state = {
    editPartModalOpen: false
  };

  componentDidMount() {
    this.props.expire();
  }

  render() {
    const { incomingQuote } = this.props;
    const showLegacyWarning =
      !incomingQuote.get(COMPANY) ||
      (!incomingQuote.get(CONTACT) && !incomingQuote.get(PORTAL_PURCHASE));

    return (
      <div>
        <Header incomingQuote={incomingQuote} />
        <div className="row">
          <Col md={3}>
            <DetailsTable incomingQuote={incomingQuote} />
          </Col>
          <Col md={9}>
            {showLegacyWarning && legacyWarning}
            <LineItemsTable quote={incomingQuote} />
            <Notes
              resource={incomingQuote}
              resourceType={resourceTypes.incomingQuote}
              resourceKey="incomingQuote"
            />
            <hr className="hr-dashed" />
            <Attachments
              resource={incomingQuote}
              resourceType={resourceTypes.incomingQuote}
              resourceKey="incomingQuote"
              attachmentTypes={ATTACHMENT_TYPES}
              multiple
            />
          </Col>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    incomingQuote: state.incomingQuoteDetail.get("incomingQuote")
  }),
  dispatch => ({
    expire: () => dispatch(incomingQuotePagination.pageActions.expire())
  })
)(
  loadRecord({
    reducer: "incomingQuoteDetail",
    name: "incomingQuote",
    action: id => getQuote(id, "no_lines")
  })(Detail)
);



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Detail/IncomingQuoteDetail.jsx